import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

import { initSentry } from '@utils/sentry';

// Initialize Sentry in production
if (import.meta.env.MODE === 'production') {
  initSentry();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
